module.exports = __webpack_public_path__ + "img/report-9.c61e0219.jpg";